import gql from 'graphql-tag';

const ARCHIVE_CLASSROOM = gql`
  mutation archiveClassroom($classroomId: Int!) {
    archiveClassroom(where: { id: $classroomId }) {
      id
      dateArchived
    }
  }
`;

export default ARCHIVE_CLASSROOM;
